if (!customElements.get('scroll-video-animation')) {
  class ScrollVideoAnimation extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    setActiveSwitcher(index, remove = false) {
      if (this.settings.switcherItems && this.settings.switcherItems.length > 0) {
        this.settings.switcherItems.forEach(switcherItem => {
          switcherItem.classList.remove("visible");
        });
        if (!remove) {
          this.settings.switcherItems[index].classList.add("visible");
        } else if (index > 0) {
          this.settings.switcherItems[index - 1].classList.add("visible");
        }
      }
    }

    scrollEventOld() {
      this.settings.reviews.forEach((review, index) => {
        const blockSettings = review.getBoundingClientRect();
        const stepBottom = blockSettings.top - window.innerHeight + blockSettings.height / 2;
        if (stepBottom < 0 && !review.classList.contains("visible")) {
          review.style.opacity = 1;
          review.classList.add("visible");
          this.setActiveSwitcher(index);
        } else if (stepBottom >= 0 && review.classList.contains("visible")) {
          review.style.opacity = 0;
          review.classList.remove("visible");
          this.setActiveSwitcher(index, true);
        }
      });
    }

    scrollSwitcherEvent(event) {
      if (this.mql.matches) {
        let index = parseInt(event.target.dataset.switcherIndex);
        this.settings.reviews[index].scrollIntoView(false);
      } else {
        let index = parseInt(event.target.dataset.switcherIndex);
        this.setActiveSwitcher(index);
        this.slider.scrollToPosition(index);
      }
    }

    callbackChangePosition(index) {
      this.setActiveSwitcher(index);
    }

    addScrollEvent() {
      this.settings.reviews.forEach((review) => {
        this.intersectionObserver.observe(review);
      });
    }

    removeScrollEvent() {
      this.settings.reviews.forEach((review) => {
        this.intersectionObserver.unobserve(review);
      });
    }

    checkWindowSize () {
      this.mql = window.matchMedia('(min-width: 750px)');
      if (this.mql.matches && this.scrollEventState === false) {
        this.scrollEventState = true;
        this.addScrollEvent();
      } else if (!this.mql.matches && this.scrollEventState === true) {
        this.removeScrollEvent();
        this.settings.reviews.forEach((review) => {
          review.style.opacity = "";
          review.classList.remove("visible");
          this.setActiveSwitcher(0);
          this.settings.reviews[0].scrollIntoView(false);
        });
        this.scrollEventState = false;
      }
    }

    init () {
      this.slider = this.querySelector("slider-component");
      this.slider.callbackChangePosition = this.callbackChangePosition.bind(this);
      this.scrollEventState = false;
      this.settings = {
        reviews: this.querySelectorAll("[data-scroll-item]"),
        switcherItems: this.querySelectorAll("[data-switcher-index]")
      };
      // console.log(this.settings.reviews);
      this.intersectionObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          const blockSettings = entry.boundingClientRect;
          const stepBottom = blockSettings.top - window.innerHeight + blockSettings.height / 2;
          if (stepBottom < 0 && !entry.target.classList.contains("visible")) {
            // console.log(entry.target);
            entry.target.style.opacity = 1;
            entry.target.classList.add("visible");
            this.setActiveSwitcher(parseInt(entry.target.dataset.scrollIndex));
          } else if (stepBottom >= 0 && entry.target.classList.contains("visible")) {
            entry.target.style.opacity = 0;
            entry.target.classList.remove("visible");
            this.setActiveSwitcher(parseInt(entry.target.dataset.scrollIndex), true);
          }
        });
      }, {
        rootMargin: '0px',
        threshold: 0.5
      });

      if (this.settings.switcherItems && this.settings.switcherItems.length > 0) {
        this.settings.switcherItems.forEach(switcherItem => {
          switcherItem.addEventListener("click", this.scrollSwitcherEvent.bind(this));
        });
      }
      this.setActiveSwitcher(0);
      this.checkWindowSize();
      window.addEventListener("resize", () => {
        this.checkWindowSize();
      });
    }
  }

  customElements.define('scroll-video-animation', ScrollVideoAnimation);
}
